export default __webpack_public_path__ + "static/media/item_image.69c4373a.png";